import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeTrackLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3565_24190)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M45.2192 16.5C46.0487 18.8463 46.5 21.3712 46.5 24.0014C46.5 36.4285 36.4255 46.5 23.9987 46.5C11.5715 46.5 1.5 36.4285 1.5 24.0014C1.5 11.5744 11.5715 1.5 23.9987 1.5C31.1039 1.5 37.44 4.79345 41.5638 9.93701",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.5 25.0918H42.7472",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.78271 25.0918H7.02991",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 7.35669L24 5.1095",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 43.074L24 40.8268",
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 23.25,
				y: 12.3811,
				width: 1.5,
				height: 13.562,
				rx: .75,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.2369 4.73696L42.3554 9.80787C42.521 10.559 41.8121 11.2081 41.0784 10.9771L36.1112 9.41252C35.3757 9.18082 35.1681 8.23887 35.7382 7.71949L39.5869 4.21312C40.1554 3.69523 41.0713 3.98601 41.2369 4.73696Z",
				fill: "black",
				fillOpacity: .08
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 24.6428,
				r: 1.42456,
				fill: "#A8AAE3"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3565_24190",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}) })]
});
export default SvgTimeTrackLight;
